module.exports = __webpack_public_path__ + "img/CothinkrJustLogo.435ff387.svg";